module.exports = __webpack_public_path__ + "img/_icon_paylink.5b4ff215.svg";